export const aboutContent = {
  subtitle: "Learn more about our journey and values",
  title: 'About Us',
  description: 'At Cygnet Call Centre, we are dedicated to providing exceptional call centre services. Our team of professionals is committed to delivering personalized and efficient customer service to help your business thrive. With our expertise and state-of-the-art technology, we offer customized solutions tailored to your unique needs.',
  mission: "Our mission is to empower businesses of all sizes by providing reliable, efficient, and cost-effective call centre services, enabling them to connect with their customers and drive growth.",
  vision: "Our vision is to be a trusted partner for our clients, supporting them in achieving their business objectives and building long-lasting relationships.",
  team: [
    {
      name: "John Doe",
      position: "CEO",
      imageUrl: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      bio: "John has over 20 years of experience in the call centre industry and is passionate about delivering exceptional customer service."
    },
    {
      name: "Jane Smith",
      position: "CTO",
      imageUrl: "https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      bio: "Jane is a technology enthusiast with a background in software development and IT management."
    },
    {
      name: "Alice Johnson",
      position: "COO",
      imageUrl: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      bio: "Alice has a wealth of experience in operations management and is dedicated to ensuring smooth and efficient processes."
    }
  ],
  helmet: {
    title: "About Us — Cygnet Call Centre | Trusted UK Call Handling Since 2000",
    description: "Cygnet Call Centre has supported UK businesses since 2000. Over 26 years of professional call handling. We listen. We care. We deliver.",
    keywords: "About Cygnet Call Centre, UK call centre since 2000, our mission, our values",
    ogTitle: "About Us — Cygnet Call Centre | Trusted Since 2000",
    ogDescription: "Cygnet Call Centre has supported UK businesses since 2000. Over 26 years of professional call handling. We listen. We care. We deliver.",
    ogType: "website",
    ogUrl: "https://www.cygnetcall.co.uk/about-us",
    ogImage: "https://www.cygnetcall.co.uk/cygnet-logo.jpg",
    twitterCard: "summary_large_image",
    twitterTitle: "About Us — Cygnet Call Centre | Trusted Since 2000",
    twitterDescription: "Cygnet Call Centre has supported UK businesses since 2000. We listen. We care. We deliver.",
    twitterImage: "https://www.cygnetcall.co.uk/cygnet-logo.jpg"
  }
};
